import actions from './actions-auth.js'
import mutations from './mutations-auth.js'
import getters from './getters-auth.js'
import state from './state-auth.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}